import React, { useState } from 'react';
import { LuMapPin, LuPhone, LuMail, LuClock, LuCheck } from 'react-icons/lu';
import './Contact.css';
import Seo from '../components/Seo';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', message: '' });
  const [sent, setSent] = useState(false);

  const handle = e => setForm({ ...form, [e.target.name]: e.target.value });

  const submit = e => {
    e.preventDefault();
    // TODO: Connect to your form handler (EmailJS, Formspree, backend, etc.)
    setSent(true);
  };

  return (
    <div className="contact-page">
      <Seo
        title="Contact | Cardona Auto Detailing"
        description="Get in touch to book your mobile car detailing in Cookeville and Algood, TN. Call or WhatsApp: (931) 310-6581."
        path="/contact"
      />
      <div className="page-header">
        <div className="page-header-bg contact-bg"></div>
        <div className="page-header-overlay"></div>
        <div className="container page-header-content">
          <p className="section-label">Get In Touch</p>
          <h1 className="section-title">CONTACT US</h1>
        </div>
      </div>

      <section className="page-section">
        <div className="container contact-grid">
          {/* INFO */}
          <div className="contact-info">
            <p className="section-label">Reach Us</p>
            <h2 className="section-title">LET'S TALK</h2>
            <div className="gold-line"></div>
            <p className="contact-intro">
              Have questions about our services, pricing, or availability?
              Send us a message or reach out directly — we respond fast.
            </p>

            <div className="info-items">
              <div className="info-item">
                <span className="info-icon" aria-hidden="true"><LuMapPin /></span>
                <div>
                  <strong>Service Area</strong>
                  <p>[Your City, Country — we come to you]</p>
                </div>
              </div>
              <div className="info-item">
                <span className="info-icon" aria-hidden="true"><LuPhone /></span>
                <div>
                  <strong>Phone / WhatsApp</strong>
                  <p><a href="tel:+19313106581">(931) 310-6581</a></p>
                </div>
              </div>
              <div className="info-item">
                <span className="info-icon" aria-hidden="true"><LuMail /></span>
                <div>
                  <strong>Email</strong>
                  <p><a href="mailto:owner@cardonaautodetailing.com">owner@cardonaautodetailing.com</a></p>
                </div>
              </div>
              <div className="info-item">
                <span className="info-icon" aria-hidden="true"><LuClock /></span>
                <div>
                  <strong>Hours</strong>
                  <p>[Mon–Sat: 8:00 AM – 6:00 PM]</p>
                </div>
              </div>
            </div>

            <div className="contact-socials">
              <a href="https://www.instagram.com/cardonaautodetailingtn/" target="_blank" rel="noopener noreferrer" className="social-link">Instagram</a>
              <a href="https://www.facebook.com/profile.php?id=61591680082145" target="_blank" rel="noopener noreferrer" className="social-link">Facebook</a>
              <a href="#tiktok" className="social-link">TikTok</a>
            </div>
          </div>

          {/* FORM */}
          <div className="contact-form-wrap">
            {sent ? (
              <div className="form-success">
                <span className="success-icon" aria-hidden="true"><LuCheck /></span>
                <h3>Message Sent!</h3>
                <p>We'll get back to you within 24 hours.</p>
                <button className="btn-outline" onClick={() => setSent(false)}>Send Another</button>
              </div>
            ) : (
              <form className="contact-form" onSubmit={submit}>
                <h3>Send a Message</h3>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="contact-name">Full Name</label>
                    <input
                      id="contact-name"
                      type="text"
                      name="name"
                      placeholder="Your name"
                      value={form.name}
                      onChange={handle}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="contact-email">Email</label>
                    <input
                      id="contact-email"
                      type="email"
                      name="email"
                      placeholder="you@email.com"
                      value={form.email}
                      onChange={handle}
                      required
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="contact-phone">Phone (optional)</label>
                  <input
                    id="contact-phone"
                    type="tel"
                    name="phone"
                    placeholder="+000 000 0000"
                    value={form.phone}
                    onChange={handle}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="contact-message">Message</label>
                  <textarea
                    id="contact-message"
                    name="message"
                    rows="5"
                    placeholder="Tell us about your vehicle and what you need..."
                    value={form.message}
                    onChange={handle}
                    required
                  ></textarea>
                </div>
                <button type="submit" className="btn-primary form-submit">
                  Send Message →
                </button>
              </form>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
